import React from 'react';

import { GridHelper } from 'components/Grids/GridHelper';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import ValidationResultCell from 'components/ReactTable/CellRenderers/ValidationResultCell';
import Chapter3Status from 'common/Customers/Chapter3Status';
import Chapter4Status from 'common/Customers/Chapter4Status';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const validFormColumnDefs = permissions => [
  {
    Header: 'Customer Id',
    accessor: 'customer',
    Cell: cellInfo => (
      <CustomerLinkCell dataKey="customerDbId" data={ cellInfo.row.original } permissions={ permissions } />
    ),
    className: 'col-10p'
  },
  {
    Header: 'Form Type',
    accessor: 'formTypeDescription',
    Filter: MultiSelectFilter
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStatus',
    Filter: MultiSelectFilter,
    Cell: cellInfo => ((cellInfo.row.original.workflowStatus) ? cellInfo.row.original.workflowStatus : 'N/A')
  },
  {
    Header: 'Account',
    accessor: 'account',
    Cell: cellInfo => (
      <AccountLinkCell dataKey="accountId" data={ cellInfo.row.original } permissions={ permissions } />
    ),
    className: 'col-10p'
  },
  {
    Header: 'Warnings / Instructions',
    id: 'warnings',
    Cell: cellInfo => (
      <ValidationResultCell dataKey="warnings" data={ cellInfo.row.original.validationData } className="red-flags-and-recs-list" />
    ),
    disableFilters: true,
    className: 'col-15p warnings-list'
  },
  {
    Header: 'Ch. 3 Status',
    accessor: 'chapter3Status',
    Filter: MultiSelectFilter,
    options: Chapter3Status.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'Ch. 4 Status',
    accessor: 'chapter4Status',
    Filter: MultiSelectFilter,
    options: Chapter4Status.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'Sign Date',
    accessor: 'signDate',
    disableFilters: true
  },
  {
    Header: 'Validity Date',
    accessor: 'validUntil',
    Cell: (cellInfo) => {
      let tmp;
      if (cellInfo.row.original.validUntil === 1000) {
        tmp = 'Evergreen';
      } else {
        tmp = GridHelper.dateFormatter(cellInfo.row.original.validUntil, 'MMM DD, YYYY');
      }
      return tmp;
    },
    disableFilters: true,
  },
  {
    Header: 'Treaty Country',
    accessor: 'treatyCountry',
    className: 'col-7p5'
  },
];

export default validFormColumnDefs;
